// extracted by mini-css-extract-plugin
module.exports = {"bannercontainer":"Banner_bannercontainer__3IXhg","image":"Banner_image__M9jUv","bannerheading":"Banner_bannerheading__Q3oSB"};